import { lazy } from "react";

const Home = lazy(() => import("../pages/home/Home"));
const HomePreview = lazy(() => import("../pages/preview/home"));
const HomeComponentDetail = lazy(() => import("../pages/detail/home"));
const WeddingItemListPage = lazy(() => import("../pages/weddingItems/WeddingItemListPage"));
const FittingRoom = lazy(() => import("../pages/fitting-room"));
const Search = lazy(() => import("../pages/search/Search"));
const SearchResult = lazy(() => import("../pages/search/Result"));
const CategoryList = lazy(() => import("../pages/category/List"));
const PlannerConsulting = lazy(() => import("../pages/consulting/PlannerConsulting"));
const Faq = lazy(() => import("../pages/Faq"));
const HealthBalance = lazy(() => import("../pages/healthBalance"));
const CashCuration = lazy(() => import("../pages/cashCuration"));
const ChungdamIntro = lazy(() => import("../pages/chungdam/ChungdamIntro"));
const ChungdamPrograms = lazy(() => import("../pages/chungdam/ChungdamPrograms"));
const HoneymoonApply = lazy(() => import("../pages/honeymoon/Apply"));
const HoneymoonComplete = lazy(() => import("../pages/honeymoon/Complete"));
const SDMPackageApply = lazy(() => import("../pages/sdmPackage/Apply"));
const SDMPackageApplyComplete = lazy(() => import("../pages/sdmPackage/Complete"));
const RedirectPage = lazy(() => import("../pages/Redirect"));
const VipApply = lazy(() => import("../pages/vip/Apply"));
const Inquiry = lazy(() => import("../pages/community/Inquiry"));
const Image = lazy(() => import("../pages/image/Image"));
const Folder = lazy(() => import("../pages/image/Folder"));
const NoMeta = lazy(() => import("../pages/no-meta/noMeta"));

export const indexRoutes = [
  // 홈 화면
  { path: "/home", element: <Home /> },
  { path: "/home/preview", element: <HomePreview /> },
  { path: "/home/detail/:componentId", element: <HomeComponentDetail /> },

  // 예약(앱 메인) 탭
  { path: "/wedding-items", element: <WeddingItemListPage /> },

  // 컨설팅|플래너|스드메본 신청
  { path: "/consulting/info", element: <PlannerConsulting /> },
  // 플래너 상담 신청 A/B 테스트 때 개발된 페이지 - 외부에 공개된 주소가 있어서 라우팅은 냅둠
  { path: "/consulting/info/additional", element: <PlannerConsulting /> },
  { path: "/fitting-room", element: <FittingRoom /> },

  // 검색화면
  { path: "/search", element: <Search /> },
  { path: "/search/result", element: <SearchResult /> },

  { path: "/category/:id", element: <CategoryList /> },

  { path: "/faq", element: <Faq /> },

  // 헬스 밸런스
  { path: "/health-balance/collection", element: <HealthBalance /> },

  // 캐시 큐레이션
  { path: "/cash-curation", element: <CashCuration /> },

  { path: "/chungdam/intro", element: <ChungdamIntro /> },
  { path: "/chungdam/programs", element: <ChungdamPrograms /> },

  { path: "/honeymoon/apply", element: <HoneymoonApply /> },
  { path: "/honeymoon/apply/complete", element: <HoneymoonComplete /> },

  { path: "/sdm-package/apply", element: <SDMPackageApply /> },
  { path: "/sdm-package/apply/complete", element: <SDMPackageApplyComplete /> },

  { path: "/vip/apply", element: <VipApply /> },
  // 커뮤니티 문의하기
  { path: "/community/inquiry", element: <Inquiry /> },

  // 이미지 페이지
  { path: "/image", element: <Image /> },
  { path: "/folder", element: <Folder /> },

  // 기타
  { path: "/no-meta", element: <NoMeta /> },
  { path: "/redirect", element: <RedirectPage /> },
];
